import React, { useState, useEffect } from "react";
import { faqContent } from "../utils/routes";
import img from "../assets/img/Background.png";
import faq from "../assets/img/Faq.svg";
import parse from "html-react-parser";
import Accordion from "react-bootstrap/Accordion";
import { Audio, Oval, Rings } from "react-loader-spinner";

function Faqs() {
  const [faqsdata, setFaqsData] = useState({
    frequently_asked_questions: "",
    frequently_asked_question_description: "",
    frequently_asked_questions_table: "",
    faq_table: "",
  });
  const [faqcontent, setFaqcontent] = useState({});
  const [faqtable, setFaqTable] = useState({});
  const [lastque, setLastQue] = useState({});

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    var object = {
      id: 5,
    };

    const getUserRequestDTO = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(object),
    };
    fetch(faqContent, getUserRequestDTO)
      .then((res) => res.json())
      .then((result) => {
        setLoading(false);
        setFaqsData(result.msg);
        var faqsQueAns = JSON.parse(
          result.msg.frequently_asked_questions_table,
        );
        setFaqTable({ faqsQueAns });
        var faqTbCon = JSON.parse(result.msg.faq_table);
        setFaqcontent({ faqTbCon });
        var faqlast = JSON.parse(result.msg.faq_table_question);
        setLastQue({ faqlast });
      });
  }, []);

  const parseTableData = (rowData, index) => {
    if (faqtable?.faqsQueAns?.charges) {
      let headers = Object.keys(rowData);
      return headers?.map((key, index) => {
        return <td className="table-td-faq">{rowData[key]}</td>;
      });
    }
  };
  const renderTableHeader = () => {
    if (faqtable?.faqsQueAns?.charges[0]) {
      let header = Object.keys(
        faqtable?.faqsQueAns?.charges[0],
        faqtable?.faqsQueAns?.charges[0],
      );
      return header?.map((key, index) => {
        return (
          <th
            className="th-faq"
            style={{ color: "white", textAlign: "center" }}
            key={index}
          >
            {key}
          </th>
        );
      });
    }
  };

  const renderTableData = () => {
    return faqtable?.faqsQueAns?.charges?.map((charge, index) => {
      return (
        <>
          <tr className="table__row">{parseTableData(charge, index)}</tr>
        </>
      );
    });
  };

  return (
    <div>
      <div className={loading === true ? "overlay" : " "}>
        <p id="loading">
          {loading ? <Rings color="#91298c" height={160} width={160} /> : null}
        </p>
      </div>

      <section className="faq__section-one ">
        <div className="container">
          <div className="row  ">
            <div className="col-sm-12 col-md-6">
              <div className="faq__mainheading">
                <h1>{parse(faqsdata.frequently_asked_questions)}</h1>
                <p>{faqsdata.frequently_asked_question_description}</p>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 order-first order-md-last">
              <center>
                <div>
                  <img className="img-fluid-hero" src={faq}></img>
                </div>
              </center>
            </div>
          </div>
        </div>
      </section>

      <section className="faq__section-two">
        <div className="container">
          <Accordion>
            {faqcontent?.faqTbCon?.map((impect, index) => {
              return impect?.isTable == "false" ? (
                <>
                  <Accordion.Item eventKey={index}>
                    <Accordion.Header>{impect.ques}</Accordion.Header>
                    <Accordion.Body>
                      <p style={{ backgroundColor: "9A809A" }}>
                        {parse(impect.ans)}
                      </p>
                    </Accordion.Body>
                  </Accordion.Item>
                </>
              ) : impect?.isTable == "true" ? (
                <Accordion.Item eventKey={index} className="accordion-table">
                  {lastque?.faqlast?.map((lastque, index) => {
                    return (
                      <>
                        <Accordion.Header>{lastque.ques}</Accordion.Header>

                        <Accordion.Body>
                          <p>{lastque.ans}</p>

                          <div className="table-wrapper">
                            <table
                              id="charges"
                              className="table table-bordered table-responsive sortable bordered"
                              style={{ backgroundColor: "#210321" }}
                            >
                              <tbody>
                                <tr>{renderTableHeader()}</tr>

                                {renderTableData()}
                              </tbody>
                            </table>
                          </div>
                        </Accordion.Body>
                      </>
                    );
                  })}
                </Accordion.Item>
              ) : null;
            })}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
export default Faqs;
